import {
  Component,
  Inject,
  OnInit
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import Swal from 'sweetalert2';

import { ClientIncidentsService } from 'src/app/services/clientIncident/clientIncident.service';

@Component({
  selector: 'app-add-incident',
  templateUrl: './add-incident.component.html',
  styleUrls: ['./add-incident.component.scss']
})
export class AddIncidentComponent implements OnInit {

  public form: FormGroup;

  public loading = false;

  constructor(
    private fb: FormBuilder,
    private incidentsService: ClientIncidentsService,
    private dialogRef: MatDialogRef<AddIncidentComponent>,

    @Inject(MAT_DIALOG_DATA)
    public data: any
  ) { }

    ngOnInit(): void {

        this.form = this.fb.group({
            asistente: ['', Validators.required],
            fechaIncidencia: ['', Validators.required],
            titulo: ['', Validators.required],
            comentarios: [''],
            comentariosSupervisor: ['']
        });

        if (this.data?.incident) {
                this.form.patchValue({

                asistente:
                    this.data.incident.asistente,
                fechaIncidencia:
                    new Date(this.data.incident.fechaIncidencia)
                    .toISOString()
                    .split('T')[0],
                titulo:
                    this.data.incident.titulo,
                comentarios:
                    this.data.incident.comentarios,
                comentariosSupervisor:
                    this.data.incident.comentariosSupervisor
            });
        }
    }

async save() {

    if (this.form.invalid) {

        return Swal.fire({
        icon: 'warning',
        title: 'Completa todos los campos obligatorios'
        });
    }

    try {

        this.loading = true;

        const payload = {
            clientId:
                this.data.clientId,
            asistente:
                this.form.value.asistente,
            fechaIncidencia:
                this.form.value.fechaIncidencia,
            titulo:
                this.form.value.titulo,
            comentarios:
                this.form.value.comentarios,
            comentariosSupervisor:
                this.form.value.comentariosSupervisor
        };

        if (this.data?.incident) {

        await this.incidentsService
            .updateIncident(
            this.data.incident._id,
            payload
            );

        } else {

        await this.incidentsService
            .createIncident(
            payload
            );
        }

        this.dialogRef.close(true);

    } catch (error) {

        console.error(error);

        Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'No fue posible guardar la incidencia'
        });

    } finally {

        this.loading = false;
    }
}

  close() {

    this.dialogRef.close(false);
  }

}